export const sizes = {
  fontSize: {
    heading1: 54,
    heading2: 42,
    heading3: 32,
    headerline: 30,
    title: 22,
    subtitle: 18,
    tableHeader: 20,
    body: 16,
    button: 16,
    label: 14,
    caption: 12,
  },
  spacings: {
    zero: 0,
    xxxs: 4,
    xxs: 6,
    xs: 8,
    sm: 10,
    md: 12,
    lg: 16,
    xl: 20,
    xxl: 28,
    xxxl: 32,
    xxxxl: 40,
    xxxxxl: 108,
  },
  borderRadius: {
    zero: 0,
    xxs: 4,
    xs: 8,
    sm: 16,
    md: 20,
    lg: 32,
    xl: 48,
    xxl: 52,
    xxxl: 64,
  },
  borderWidth: {
    xxs: 1,
    xs: 2,
    sm: 3,
  },
} as const
